/*

1、未涉及文件上传的api不要用这个request
2、文件上传的api必须用这个request

*/

import axios from 'axios'
import { getToken } from '@/utils/auth'
import sendError from './sendError'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: '', // api的base_url
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (getToken()) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    if (!response || !response.data) {
      return response
    } else if (response.data.ErrorCode === 3) {
      window.location.href = '/login'
    } else if (response.data.ErrorCode !== 0 && /.*[\u4e00-\u9fa5]+.*/.test(response.data.Msg)) {
      // 错误消息弹出提示
      const chineseMsg = ['数据验证失败', '程序访问异常,请稍后重试！']
      const enMsg = ['Data verification failed', 'Program access is abnormal, please try again later!']
      switch (response.data.Msg) {
        case chineseMsg[0]:
          response.data.Msg = enMsg[0]
          break
        case chineseMsg[1]:
          response.data.Msg = enMsg[1]
          break
      }
    }
    return response
  },

  error => {
    console.log('err' + error)// for debug
    // if(err)
    sendError('Links seem to get inaccessible.')
    // debounce(main.$toasted.error(error), 5000)
    // TODO: trigger snakebar
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  })

export default service
